// apps/client/src/components/Workspace/WorkspaceSettings/useWorkspaceSettingsShortcut.ts
import { useAtomValue, useSetAtom } from 'jotai'
import { workspaceChallengeAtom, workspaceSettingsOpenAtom, workspaceTaskAtom } from '@/store/workspaceAtoms'
import { trackWorkspaceSettings } from '@/modules/workspaceSettingsAnalytics'
import { useShortcut } from '@/modules/Shortcuts'

/**
 * Registers the global Cmd/Ctrl+, shortcut that toggles the Workspace
 * Settings dialog. Mount once from Workspace.
 */
export const useWorkspaceSettingsShortcut = () => {
  const setOpen = useSetAtom(workspaceSettingsOpenAtom)
  const challenge = useAtomValue(workspaceChallengeAtom)
  const task = useAtomValue(workspaceTaskAtom)

  useShortcut({
    id: 'workspace.settings.open',
    keys: { cmd: true, key: ',' },
    group: 'general',
    labelKey: 'common.shortcutsSettingsOpen',
    handler: () => {
      setOpen((prev) => {
        const next = !prev
        if (next) {
          trackWorkspaceSettings('workspace_settings:open', {
            source: 'shortcut',
            challengeId: challenge?.id,
            taskId: task?.id,
          })
        }
        return next
      })
    },
  })
}
